export async function loadLocaleData(locale: string): Promise<any> {
  switch (locale) {
    case 'es':
      return import('../locales/es.json');
    case 'en':
    default:
      return import('../locales/en.json');
  }
}
